import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { InlineAlertTypes } from '@app/shared/types/inline-alert-types';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'tc-alert-box',
    imports: [
        CommonModule,
        TranslateModule
    ],
    templateUrl: './alert-box.component.html',
    styleUrls: ['./alert-box.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None
})
export class AlertBoxComponent {

    @Input() title: string; 
    @Input() buttonTitle: string;
    @Input() body: string;
    @Input() secondBody: string;
    @Input() alertType: InlineAlertTypes;
    @Input() translatedValues:any;
    @Input() personalInfoVerified: boolean;
    @Input() hasButton: boolean;
    @Input() icon: string;

    alertTypes = InlineAlertTypes;
    
    constructor() {

    }


}
